<script>
import { useField } from '@phoenix/composables/field';
import fieldMixin from '@maison/mixins/fieldMixin';
import { defineAsyncComponent } from 'vue';

const CheckboxField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxField.vue'));
const CheckboxColorField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxColorField.vue'));

export default {
  components: {
    CheckboxColorField,
    CheckboxField,
  },

  mixins: [fieldMixin],

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'default',
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    checkboxComponent() {
      switch (this.type) {
        case 'color':
          return CheckboxColorField;
        default:
          return CheckboxField;
      }
    },
  },
};
</script>

<template>
  <component
    :is="checkboxComponent"
    v-for="option in field.options"
    :key="`${field.id}-${option.id}`"
    v-model="value"
    :parent-id="field.id"
    :attrs="option"
    :should-validate="false"
  />
</template>
